export const THIRTY_TGAS = '30000000000000'
export const NO_DEPOSIT = '0'

export function generateAction(
  methodName,
  args = {},
  gas = THIRTY_TGAS,
  deposit = NO_DEPOSIT
) {
  return {
    type: 'FunctionCall',
    params: {
      methodName,
      args,
      gas,
      deposit
    }
  }
}

export function generateTransaction(receiverId, actions) {
  return { receiverId, actions }
}

export async function viewMethod({ provider, contractId, method, args = {} }) {
  const response = await provider.query({
    request_type: 'call_function',
    account_id: contractId,
    method_name: method,
    args_base64: Buffer.from(JSON.stringify(args)).toString('base64'),
    finality: 'optimistic'
  })

  const result = Buffer.from(response.result).toString()

  try {
    return JSON.parse(result)
  } catch (e) {
    return result
  }
}

export async function sendBatchTransactions(wallet, transactions) {
  return wallet.signAndSendTransactions({
    transactions
  })
}

export async function callMethods({ wallet, accountId, contractId, actions }) {
  return wallet.signAndSendTransaction({
    signerId: accountId,
    receiverId: contractId,
    actions
  })
}

export async function callMethod({
  wallet,
  accountId,
  contractId,
  method,
  args = {},
  gas = THIRTY_TGAS,
  deposit = NO_DEPOSIT
}) {
  return callMethods({
    wallet,
    accountId,
    contractId,
    actions: [generateAction(method, args, gas, deposit)]
  })
}

export async function viewAccount(provider, accountId) {
  return provider.query({
    request_type: 'view_account',
    account_id: accountId,
    finality: 'optimistic'
  })
}
